import { useTheme } from '@mui/material/styles';
import createAvatar from 'src/utils/createAvatar';
import Avatar, { Props as AvatarProps } from './Avatar';
import useCurrentUser from 'src/hooks/useCurrentUser';
import { BRAND } from 'src/theme/palette';

export default function MyAvatar({ ...other }: AvatarProps) {
  const theme = useTheme();
  const user = useCurrentUser();

  return (
    <Avatar
      // src={user?.photoURL}
      alt={user?.firstName}
      sx={{
        backgroundColor: theme.palette.secondary.main, // Charcoal gray
        color: BRAND.white,
        ...other.sx,
        ml: {
          xs: 1,
        },
      }}
      {...other}
    >
      {createAvatar(user?.firstName).name}
    </Avatar>
  );
}
